/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { copilotAuditLog } from '../models/copilotAuditLog';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CopilotAuditLogsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count copilotAuditLogs
   * Count copilotAuditLogs (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of copilotAuditLog documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCopilotAuditLogsCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/copilotAuditLogs/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one copilotAuditLog
   * Find one copilotAuditLog by its unique identifier.
   * @param identifier copilotAuditLog unique identifier
   * @returns any One copilotAuditLog document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCopilotAuditLogs(
    identifier: string,
  ): CancelablePromise<{
    data?: copilotAuditLog;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/copilotAuditLogs/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace one copilotAuditLog which exists or not
   * Replace one copilotAuditLog which exists or not
   * @param identifier copilotAuditLog unique identifier
   * @param requestBody
   * @returns any copilotAuditLog replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCopilotAuditLogs(
    identifier: string,
    requestBody?: copilotAuditLog,
  ): CancelablePromise<{
    data?: copilotAuditLog;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/copilotAuditLogs/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing copilotAuditLog
   * Partially update one existing copilotAuditLog
   * @param identifier copilotAuditLog unique identifier
   * @param requestBody
   * @returns any updated copilotAuditLog. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCopilotAuditLogs(
    identifier: string,
    requestBody?: copilotAuditLog,
  ): CancelablePromise<{
    data?: copilotAuditLog;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/copilotAuditLogs/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one copilotAuditLog
   * Delete one copilotAuditLog
   * @param identifier copilotAuditLog unique identifier
   * @returns any delete status copilotAuditLogs. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsCopilotAuditLogs(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/copilotAuditLogs/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many copilotAuditLogs
   * Find many copilotAuditLogs (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many copilotAuditLog documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCopilotAuditLogs1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<copilotAuditLog>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/copilotAuditLogs',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple copilotAuditLogs
   * Create one or multiple copilotAuditLogs
   * @param requestBody
   * @returns any One or many copilotAuditLog documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServiceorganizationsCopilotAuditLogs(
    requestBody?: (copilotAuditLog | Array<copilotAuditLog>),
  ): CancelablePromise<{
    data?: (copilotAuditLog | Array<copilotAuditLog>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/copilotAuditLogs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace many copilotAuditLogs which exists or not
   * Replace many copilotAuditLogs which exists or not
   * @param requestBody
   * @returns any copilotAuditLogs replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCopilotAuditLogs1(
    requestBody?: Array<copilotAuditLog>,
  ): CancelablePromise<{
    data?: Array<copilotAuditLog>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/copilotAuditLogs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing copilotAuditLog
   * Partially update many existing copilotAuditLog
   * @param requestBody
   * @returns any copilotAuditLogs updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCopilotAuditLogs1(
    requestBody?: Array<copilotAuditLog>,
  ): CancelablePromise<{
    data?: Array<copilotAuditLog>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/copilotAuditLogs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many copilotAuditLogs
   * Delete many copilotAuditLogs using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status copilotAuditLogs. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsCopilotAuditLogs1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/copilotAuditLogs',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
